import React from 'react';

export const Pagination = ({
	currentPage = 1,
	totalPages = 1,
	prevAction = Function.prototype,
	nextAction = Function.prototype,
	prevText = 'Poprzednie propozycje',
	nextText = 'Kolejne propozycje',
	...props
}) => (
	<nav role="navigation" aria-label="Paginacja">
		{currentPage < totalPages &&
		currentPage == 1 && (
			<div className="row row--justify-end">
				<a onClick={() => nextAction()} className="link" title="Przejdź do kolejnej strony">
					<span aria-hidden="true">{nextText}</span>
					<i className="fas fa-chevron-right link__icon link__icon-right" aria-hidden="true" />
				</a>
			</div>
		)}

		{currentPage > 1 &&
		currentPage < totalPages && (
			<div className="row row--justify-space">
				<a onClick={() => prevAction()} className="link row__element" title="Przejdź do poprzedniej strony">
					<i className="fas fa-chevron-left link__icon link__icon-left" aria-hidden="true" />
					<span aria-hidden="true">{prevText}</span>
				</a>
				<a onClick={() => nextAction()} className="link row__element row__element--left-20" title="Przejdź do kolejnej strony">
					<span aria-hidden="true">{nextText}</span>
					<i className="fas fa-chevron-right link__icon link__icon-right" aria-hidden="true" />
				</a>
			</div>
		)}

		{currentPage >= totalPages &&
		currentPage != 1 && (
			<div className="row">
				<a onClick={() => prevAction()} className="link" title="Przejdź do poprzedniej strony">
					<i className="fas fa-chevron-left link__icon link__icon-left" aria-hidden="true" />
					<span aria-hidden="true">{prevText}</span>
				</a>
			</div>
		)}
	</nav>
);
